import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { glassWorkPrice } from "../ServicesSlice";

// Models
export interface price {
    id: number,
    glass_id: number,
    glass_work_id: number,
    price: string,
}

// Add material state
export interface editServicePricingState {
    prices: price[],
    glassWorkPrice?: glassWorkPrice,
    isLoading: boolean,
    isSuccess: boolean,
    isOpen: boolean
}

const initialEditServicePricingState: editServicePricingState = {
    prices: [{ glass_id: 0, glass_work_id: 0, id: 0, price: "0" }],
    isLoading: false,
    isSuccess: false,
    isOpen: false
}

// Users slice
export const editServicePricingSlice = createSlice({
    name: 'edit_service_pricing',
    initialState: initialEditServicePricingState,
    reducers: {
        init: state => initialEditServicePricingState,
        set: (state, { payload }: PayloadAction<price>) => {
            state.prices = [payload]
        },
        setPriceValue: (state, { payload }: PayloadAction<any>) => {
            state.prices[0].price = payload;
            if (state.glassWorkPrice != null) {
                state.glassWorkPrice.price = payload ;
            }
        },
        setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
            state.isLoading = payload
        },
        setIsSuccess: (state, { payload }: PayloadAction<boolean>) => {
            state.isSuccess = payload
        },
        setIsOpen: (state, { payload }: PayloadAction<boolean>) => {
            state.isOpen = payload
        },
        setGlassPrice: (state, { payload }: PayloadAction<glassWorkPrice>) => {
            state.glassWorkPrice = payload
        },
    }
})